// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"LoginLayout_rootContainer__1yw6i","pageContainer":"LoginLayout_pageContainer__J9en0"};